import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { getDecryptParam } from "logic/typeDecryptParams";

import MainPage from '../Main'

import identityVerification from '../../../assets/icons/figma/identity-verification.svg'
import PageSessionExpired from "../PageSessionExpired";
import ResultPage from "../PageResult";

export default function Start() {
  const { t } = useTranslation();
  const location = useLocation();
  const [currentPage, setCurrentPage] = useState('');

  useEffect(() => {
    const { pathname } = location;
    console.log(pathname);
    
    const getParam = getDecryptParam
    console.log(getParam);
    
  }, [location])

  useEffect(() => {
    const timer = setTimeout(() => {
      setCurrentPage("MAIN");
    }, 2000);
    return () => clearTimeout(timer);
  }, [])

  useEffect(() => {
    const handler = () => {
      setCurrentPage("SESSION_EXPIRED");
    };

    window.addEventListener(
      "NEW_FLOW_SESSION_EXPIRED",
      handler
    );

    return () => {
      window.removeEventListener(
        "NEW_FLOW_SESSION_EXPIRED",
        handler
      );
    };
  }, []);

  if (currentPage === "MAIN") {
    return <MainPage />
  }

  if (currentPage === 'SESSION_EXPIRED') {
    return <PageSessionExpired />
  }
  
  return (
    <ResultPage 
      header={false}
      icon={identityVerification}
      titleText={t('เรากำลังพาคุณไปขั้นตอน \n ยืนยันตัวตน e-KYC')}
      des={t('กรุณารอสักครู่')}
    />
  )
}
